import { useEffect, useState } from "react";
import ScrollableList from "../../../../Components/ScrollableList/ScrollableList";
import UsersRequests from "../../../../Services/Api/UserRequests.ts";
import { GetPermissionsToDisplay } from "../../../../Services/Permissions/PermissionManager";
import { Permissions } from "../../../../Services/Permissions/Data/Permissions.js";
import AddEditUser from "./Components/AddEditUser/AddEditUser.js";
import { MdEdit, MdOutlineRefresh } from "react-icons/md";
import { AddToastNotification } from "../../../../Services/ToastNotification/ToastNotificationManager.js";
import ResetPasswordModal from "./Components/ResetPasswordModal/ResetPasswordModal.js";

const UserSettings = () => {
    const userRequests = new UsersRequests();

    const [showAddEdit, setShowAddEdit] = useState(false);
    const [editData, setEditData] = useState(false);
    
    const [resetPasswordUser, setResetPasswordUser] = useState(false);
    const [users, setUsers] = useState(null);

    useEffect(() => {
        refresh();
    }, [])

    const refresh = () => {
        userRequests.GetAll((data) => {
            const processedData = data.map((user) => {
                return {
                    img: {
                        src: user.steamPlayer.avatarfull,
                        className: "h-24 w-24 rounded-sm"
                    },
                    id: user.panelUser.id,
                    text: [
                        user.panelUser.login,
                        user.panelUser.email,
                        user.panelUser.steamId64,
                        user.panelUser.discordId
                    ],
                    columns: [
                        <div className="flex gap-24">
                            <div className="w-80">
                                <p><span className="text-glwhite-600">Login:</span> {user.panelUser.login}</p>
                                <p><span className="text-glwhite-600">Email:</span> {user.panelUser.email}</p>
                                <p><span className="text-glwhite-600">Steam:</span> {user.panelUser.steamId64}</p>
                                <p><span className="text-glwhite-600">Discord Id:</span> {user.panelUser.discordId}</p>
                            </div>
                            <div>
                                <h3>Uprawnienia</h3>
                                <div className="columns-4 bg-glgray-600 p-3 rounded-xl w-32 align-middle">
                                    <GetPermissionsToDisplay permissions={user.panelUser.permissions} permissionsData={Permissions}/>
                                </div>                             
                            </div>
                        </div>
                    ]
                }
            });
            
            setUsers({processedData : processedData, data : data});
        });
    }

    const edit = (id) => {
        const user = users.data.find(x => x.panelUser.id == id);
        if(user) {
            if(user.panelUser.permissions != 1) {
                setEditData(user.panelUser);
                setShowAddEdit(true);
            }
            else{
                AddToastNotification("Nie możesz edytować Roota!",  0);
            }

        }
    }

    const resetPassword = (id) => {
        const user = users.data.find(x => x.panelUser.id == id);
        if(user) {
            if(user.panelUser.permissions != 1) {
                setResetPasswordUser(user.panelUser);
            }
            else{
                AddToastNotification("Nie możesz zmienić hasła Roota!",  0);
            }
        }
    }

    const remove = (id) => {
        const user = users.data.find(x => x.panelUser.id == id);

        if(user.panelUser.permissions != 1) {
            userRequests.Delete(id, () => {
                refresh()
            });
        }
        else{
            AddToastNotification("Nie możesz usunąć Roota!",  0);
        }
    }

    if(users == null)
        return (<h1 className="text-center mt-4">Ładowanie danych...</h1>);

    return (
        <div className="mt-10">
            <ScrollableList 
                removeFunction={remove}
                setShowAdd={() => {setEditData(null); setShowAddEdit(true)}}
                data={users.processedData}
                customButtons={[
                    { icon: <MdOutlineRefresh title="Restart hasła" size={"22px"} className="iconBtn"/>, onClick: (data) => {resetPassword(data.id)} },
                    { icon: <MdEdit size={"22px"} className="iconBtn"/>, onClick: (data) => {edit(data.id)} }            
                ]}
                listClass={"overflow-y-auto overflow-x-hidden max-h-[68vh]"}
            />

            { showAddEdit &&
                <AddEditUser refresh={refresh} editData={editData} setShow={setShowAddEdit} />
            }
            { resetPasswordUser &&
                <ResetPasswordModal resetPasswordUser={resetPasswordUser} setResetPasswordUser={setResetPasswordUser}/>
            }
        </div>
    )
}

export default UserSettings;